import {useMemo} from "react";
import {css} from "@panda/css";

import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {getRandomConsultant} from "../../../lead/utils/get_random_consultant";

interface IProps {
    message?: string;
}

export const PreferencesFormHeader = (props: IProps) => {
    const {message = "Twoje konto zostało założone pomyślnie"} = props;
    const {isMobile} = useUserDevice();
    const consultant = useMemo(() => getRandomConsultant(), []);

    return (
        <div className={containerStyle}>
            <div className={consultantSectionStyle}>
                <Image
                    src={consultant.image.s72}
                    src2x={consultant.image.s144}
                    src3x={consultant.image.s216}
                    className={consultantImageStyle}
                    width={isMobile ? "44px" : "86px"}
                    height={isMobile ? "44px" : "86px"}
                    alt={consultant.fullName}
                />
                <div className={consultantInfoStyle}>
                    <Text variant="headline_6" as="div">
                        {consultant.fullName}
                    </Text>
                    <Text variant="body_copy_2" as="div" color="var(--colors-gray-700)">
                        Konsultant rynekpierwotny.pl
                    </Text>
                </div>
            </div>
            <div className={successBoxStyle}>
                <div className={successContentStyle}>
                    <div className={iconWrapperStyle}>
                        <BrandCheckboxCheckedIcon size={isMobile ? "3.2" : "4.4"} wrapperSize={isMobile ? "3.2" : "4.4"} wrapperColor="var(--colors-primary)" />
                    </div>
                    <Text variant="body_copy_2" as="div" color="var(--colors-dark-4)">
                        {message}
                    </Text>
                </div>
            </div>
        </div>
    );
};

const containerStyle = css({
    display: "flex",
    gap: 2,
    borderRadius: 2,
    flexDirection: "column",

    md: {
        gap: 5.5,
        padding: 2,
        backgroundColor: "var(--colors-gray-100)",
        flexDirection: "row",
        alignItems: "center"
    }
});

const consultantSectionStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 2,
    paddingX: 2,
    paddingY: 1,
    backgroundColor: "var(--colors-gray-100)",
    borderBottom: "1px solid var(--colors-gray-500)",
    md: {
        backgroundColor: "unset",
        borderBottom: "none",
        borderRadius: 2,
        paddingX: 1,
        paddingY: 1
    }
});

const consultantImageStyle = css({
    borderRadius: "50%",
    flexShrink: 0
});

const consultantInfoStyle = css({
    display: "flex",
    flexDirection: "column"
});

const successBoxStyle = css({
    flexGrow: 1,
    width: "100%",
    paddingX: 2,

    md: {
        paddingX: "unset",
        width: "auto"
    }
});

const successContentStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 2,
    backgroundColor: "var(--colors-success)",
    borderRadius: 1,
    padding: 1
});

const iconWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    flexShrink: 0,
    md: {
        width: "44px",
        height: "44px"
    }
});
import {useMemo} from "react";
import {css} from "@panda/css";

import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {getRandomConsultant} from "../../../lead/utils/get_random_consultant";

interface IProps {
    message?: string;
}

export const PreferencesFormHeader = (props: IProps) => {
    const {message = "Twoje konto zostało założone pomyślnie"} = props;
    const {isMobile} = useUserDevice();
    const consultant = useMemo(() => getRandomConsultant(), []);

    return (
        <div className={containerStyle}>
            <div className={consultantSectionStyle}>
                <Image
                    src={consultant.image.s72}
                    src2x={consultant.image.s144}
                    src3x={consultant.image.s216}
                    className={consultantImageStyle}
                    width={isMobile ? "44px" : "86px"}
                    height={isMobile ? "44px" : "86px"}
                    alt={consultant.fullName}
                />
                <div className={consultantInfoStyle}>
                    <Text variant="headline_6" as="div">
                        {consultant.fullName}
                    </Text>
                    <Text variant="body_copy_2" as="div" color="var(--colors-gray-700)">
                        Konsultant rynekpierwotny.pl
                    </Text>
                </div>
            </div>
            <div className={successBoxStyle}>
                <div className={successContentStyle}>
                    <div className={iconWrapperStyle}>
                        <BrandCheckboxCheckedIcon size={isMobile ? "3.2" : "4.4"} wrapperSize={isMobile ? "3.2" : "4.4"} wrapperColor="var(--colors-primary)" />
                    </div>
                    <Text variant="body_copy_2" as="div" color="var(--colors-dark-4)">
                        {message}
                    </Text>
                </div>
            </div>
        </div>
    );
};

const containerStyle = css({
    display: "flex",
    gap: 2,
    borderRadius: 2,
    flexDirection: "column",

    md: {
        gap: 5.5,
        padding: 2,
        backgroundColor: "var(--colors-gray-100)",
        flexDirection: "row",
        alignItems: "center"
    }
});

const consultantSectionStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 2,
    paddingX: 2,
    paddingY: 1,
    backgroundColor: "var(--colors-gray-100)",
    borderBottom: "1px solid var(--colors-gray-500)",
    md: {
        backgroundColor: "unset",
        borderBottom: "none",
        borderRadius: 2,
        paddingX: 1,
        paddingY: 1
    }
});

const consultantImageStyle = css({
    borderRadius: "50%",
    flexShrink: 0
});

const consultantInfoStyle = css({
    display: "flex",
    flexDirection: "column"
});

const successBoxStyle = css({
    flexGrow: 1,
    width: "100%",
    paddingX: 2,

    md: {
        paddingX: "unset",
        width: "auto"
    }
});

const successContentStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 2,
    backgroundColor: "var(--colors-success)",
    borderRadius: 1,
    padding: 1
});

const iconWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    flexShrink: 0,
    md: {
        width: "44px",
        height: "44px"
    }
});
